import _ from 'lodash';
import type { Layout } from 'types/documentServices';
import type { SlotData } from '../types';
import type { SlotOpenerScope } from '../scope';

export const debouncedSetSlot = _.debounce(
  (scope: SlotOpenerScope, slot: SlotData) => {
    scope.store.setAvailableSlot(slot);
    scope.editorAPI.setAttachCandidate({ comp: null }, true);
  },
  2000,
);

export const isMouseOverTheLine = (
  mouseCoordinates: { pageX: number; pageY: number },
  lineLayout: Layout,
) => {
  return (
    mouseCoordinates.pageX >= lineLayout.x &&
    mouseCoordinates.pageX <= lineLayout.x + lineLayout.width &&
    mouseCoordinates.pageY >= lineLayout.y &&
    mouseCoordinates.pageY <= lineLayout.y + lineLayout.height
  );
};
